import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx("div", {
    sel: '.mp-drop-menu-pane'
  }, jsx("div", {
    sel: '.mp-drop-menu-pane-title'
  }, jsx("div", {
    sel: '.mp-drop-menu-pane-title-label'
  }, this.attr("header")), this.attr("show-back-button") ? jsx("div", {
    sel: '.mp-drop-menu-pane-title-back',
    on: {
      click: this.helpers.clickedBackButton
    },
    attrs: {
      elRef: "dropMenuBackButton"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "caret-left"
    }
  })) : null), jsx("div", {
    sel: '.mp-drop-menu-pane-body'
  }, jsx("slot", null)));
}